const openSitechromeModal = ({ url, focusOnCloseElement, iFrameTitle }) => {
  const {
    openIFrameModal,
    modalTypes: { SIDE_RIGHT }
  } = window.asos.siteChrome.modals;

  openIFrameModal({
    url,
    focusOnCloseElement,
    consumer: "savedLists",
    iFrameTitle,
    modalType: SIDE_RIGHT
  });
};

export default openSitechromeModal;
